import { useContext } from "react";
import cn from "classnames";
import { Button as CommonButton, ButtonProps } from "capitalrx-components-2.0/lib/general";

import { ThemeSelectorContext } from "@/basic/context";

import styles from "../styles.module.scss";

export const Button = (props: ButtonProps) => {
  const { children, className, ...rest } = props;
  const { client } = useContext(ThemeSelectorContext);

  const buttonClass = cn({ [styles["Button"]]: !!client }, className);

  return (
    <CommonButton {...rest} className={buttonClass}>
      {children}
    </CommonButton>
  );
};
